import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'hasMore' ]

  connect() {
    this.form = this.element
    if (this.hasHasMoreTarget) {
      this._addScrollListener()
    }
  }

  _addScrollListener() {
    const options = {
      root: null, // observe in the context of the viewport
      rootMargin: '0px',
      threshold: 1.0 // 1.0 means that the callback will be executed when 100% of the target is visible.
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this._fetchMore()
        }
      })
    }, options)

    this.observer = observer
    observer.observe(this.form)
  }

  _fetchMore() {
    if (!this.hasHasMoreTarget && this.observer) {
      this.observer.unobserve(this.form)
      return
    }

    this.form.requestSubmit()
  }
}
